import hourGlassSuccessGif from '@assets/animation/sand-timer-success.gif';
import hourGlassDangerGif from '@assets/animation/sand-timer-danger.gif';
import { ModalTypes } from '../InfoModal';
import * as S from './ModalLoader.styled';
import { IModalLoaderProps } from './IModalLoader';

export const ModalLoader = (props: IModalLoaderProps): JSX.Element => {
  const { type } = props;
  const imageSrc = type === ModalTypes.Success ? hourGlassSuccessGif : hourGlassDangerGif;
  return (
    <S.Wrapper>
      <S.ModalHeader>
        <S.ModalIconWrapper>
          <img src={imageSrc} />
        </S.ModalIconWrapper>
      </S.ModalHeader>
    </S.Wrapper>
  );
};
